<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛-首页">
		<PHeader :checkId="'联系我们33'"  :activeNames="'联系我们'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">联系我们</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">Contact Us</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 联系我们</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;text-align:center;width:94%;">联系我们</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;text-align:center;width:94%;">Contact Us</div>
			<div style="margin-left: 3%;margin-top:0px;text-align:center;width:94%;margin-bottom: 30px;">
				<div style="height: 365px;margin-top: 20px;text-align: left;" v-for="(item,index) in list" :key="index">
					<div style="height: 200px;width: 100%;">
						<img style="width: 100%;height: 100%;" :src="item.img">
					</div>
					<div style="height: 30px;line-height: 35px;">
						<span style="font-size: 18px;font-weight: 600;color: #98273A;">{{item.name}}</span>
						<span style="font-size: 12px;"> /{{item.ename}}</span>
					</div>
					<div style="margin-top: 10px;margin-bottom: 5px;width: 30px;height: 2px;background-color: #98273A;"></div>
					<div style="border-top: 1px solid #DFDFDF;padding-top: 15px;min-height: 20px;">
						<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;float: left;" src="../../assets/fImage/地址.png">
						<span style="color: rgb(89, 89, 89);font-size: 14px;display: block;float: left;width: calc(100% - 35px);margin-left: 15px;">{{item.address}}</span>
					</div>
					<div style="margin-top: 15px;min-height: 20px;">
						<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;float: left;" src="../../assets/fImage/邮箱3.png">
						<span style="color: rgb(89, 89, 89);font-size: 14px;display: block;float: left;width: calc(100% - 35px);margin-left: 15px;">{{item.email}}</span>
					</div>
					<div style="margin-top: 15px;min-height: 20px;">
						<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;float: left;" src="../../assets/fImage/电话.png">
						<span style="color: rgb(89, 89, 89);font-size: 14px;display: block;float: left;width: calc(100% - 35px);margin-left: 15px;">{{item.phone}}</span>
					</div>
					<!-- <div style="margin-top: 20px;">
						<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/电话.png">
						<span style="margin-left: 15px;color: #595959;font-size: 14px;">{{item.fax}}</span>
					</div> -->
				</div>
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {create,query} from "@/api/leaveMassage";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				list:[
					{name:'上海',ename:'Shanghai',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'上海市徐汇区肇嘉浜路1065号飞雕国际大厦1509室',email:'shanghai@hehualawyer.com',phone:'021-63331010',fax:'传真传真传真传真'},
					{name:'重庆',ename:'ChongQing',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'重庆市渝中区大坪正街19号英利中心壹号14楼',email:'chongqin@hehualawyer.com',phone:'15683834405',fax:'传真传真传真传真'},
					{name:'西安',ename:'XiAn',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'西安市高新区唐延路11号禾盛京广中心E座2802室',email:'xian@hehualawyer.com',phone:'029-81773628/13389256128',fax:'传真传真传真传真'},
					{name:'唐山',ename:'Tangshan',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'河北省唐山市路北区建设北路96-1号',email:'tangshan@hehualawyer.com',phone:'0315-2037777',fax:'传真传真传真传真'},
					{name:'郑州',ename:'ZhengZhou',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'河南省郑州市郑东新区CBD商务内环路2号6层605号、606号',email:'zhengzhou@hehualawyer.com',phone:'0371-63226691',fax:'传真传真传真传真'},
					{name:'海口',ename:'HaiKou',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'海南省海口市美兰区富力首府富力中心2508室',email:'haikou@hehualawyer.com',phone:'18136135075',fax:'传真传真传真传真'},
					{name:'太原',ename:'TaiYuan',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'山西省太原市万柏林区滨河西路（南段）85号1幢A座9层',email:'taiyuan@hehualawyer.com',phone:'0351-6079116',fax:'传真传真传真传真'},
					{name:'合肥',ename:'HeFei',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'合肥所地址安徽省合肥市瑶海区当涂北路16号科硕大厦801室',email:'shaodongming@hehualawyer.com',phone:'14792368699 ',fax:'传真传真传真传真'},
					{name:'和华启核',ename:'HeHuaQiHe',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'上海市徐汇区肇嘉浜路1065号飞雕国际大厦1203室',email:'VCYu@coipcore.com',phone:'18621693420',fax:'传真传真传真传真'},
				],
				name:'',
				email:'',
				phone:'',
				area:'',
				desc:''
			}
		},
		mounted() {
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			submit(){
				if(!this.name){
					this.$message.error('请输入您的姓名')
				}else if(!this.phone){
					this.$message.error('请输入您的联系方式')
				}else if(!this.email){
					this.$message.error('请输入您的电子邮箱')
				}else if(!this.city){
					this.$message.error('请输入您的所在城市')
				}else if(!this.content){
					this.$message.error('请详细描述您请求的内容')
				}else{
					let param = {}
					param.name = this.name;
					param.phone = this.phone;
					param.email = this.email;
					param.city = this.area;
					param.content = this.desc;
					create(param).then(data => {
						this.$message.success("提交成功!")
						this.name = ''
						this.phone = ''
						this.email = ''
						this.area = ''
						this.desc = ''
					}).catch(error => {
						this.$message.error(error)
					})
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter /deep/ .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel /deep/ .el-carousel__container{
		height: 100%;
	}
	body /deep/ .v-modal{
		display: none;
	}
/* Reset */
 .btn-border-o:before{
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/* Main Styles */

.btn {
  position: relative;
}

.btn-border-o {
  background-color: transparent;    
  border: 0;
  border-bottom: 1px solid #d0d0d0;
  color: #B8B8B8;
}
.btn-border-o:before {
  content: '';
  border-style: solid;
  position: absolute;
  z-index: 5;
  box-sizing: content-box;
}
.btn-border-o:before {
  width: 0;
  height: 100%;
  border-width: 0 0 1px 0;
  top: -0.5px;
  left: 0;
}
.btn-border-o:hover:before {
  width: 100%;
}
.btn-border-o:hover:after {
  height: 100%;
}
.btn-border-o.btn-green:hover {
  color: #98273A;
}
</style>
